import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HubLoadingButtonComponent } from './hub-loading-button.component';

@NgModule({
    imports: [ CommonModule ],
    exports: [ HubLoadingButtonComponent ],
    declarations: [ HubLoadingButtonComponent ],
})
export class HubLoadingButtonModule {}
